import connectTransport from "../connect"
import ShuttlePage from "./ShuttlePage"

export default connectTransport(ShuttlePage)
